export default "__VITE_ASSET__Gi7QlNCP__"